import React, { useState } from 'react';
import api from '../../utils/api';
import './AddBranchForm.css';
import { formatPhoneNumber, unformatPhoneNumber } from '../../utils/phoneNumber';

export default function AddBranchForm() {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    phone: '+90',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      const formatted = formatPhoneNumber(value);
      setFormData({ ...formData, phone: formatted });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const payload = {
        name: formData.name,
        address: formData.address,
        phone: unformatPhoneNumber(formData.phone),
      };

      // api instance'ı interceptor sayesinde otomatik olarak Authorization header'ını ekler
      const response = await api.post('/api/branches', payload);

      if (response.data.success) {
        setMessage({ type: 'success', text: response.data.message || 'Şube başarıyla oluşturuldu' });
        setFormData({
          name: '',
          address: '',
          phone: '+90',
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Şube eklenirken bir hata oluştu';
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="branch-form-container">
      <h3>Yeni Şube Ekle</h3>
      
      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="branch-form">
        <div className="form-group">
          <label htmlFor="name">Şube Adı</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Örn: Kadıköy Şubesi"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="address">Adres</label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Örn: Kadıköy"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Telefon</label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="+90 (XXX) XXX XX XX"
            required
          />
        </div>

        <button type="submit" className="submit-button" disabled={isLoading}>
          {isLoading ? 'Ekleniyor...' : 'Şube Ekle'}
        </button>
      </form>
    </div>
  );
}
